import React from 'react';
import LockerSimulator from './LockerSimulator';
import { useAppContext } from '@/contexts/AppContext';
import { Button } from '@/components/common/Button';

const SimulatorPage: React.FC = () => {
  const { setStep } = useAppContext();

  const handleBack = () => {
    setStep(0);
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="absolute top-4 left-4 z-10">
      </div>
      <LockerSimulator />
    </div>
  );
};

export default SimulatorPage;